import type { Chord } from 'svguitar';

export const GSustChords: Record<string, Chord> = {
  'G#': {
    fingers: [
      [3, 3, '2'],
      [4, 4, '4'],
      [5, 4, '3'],
    ],
    barres: [
      {
        fromString: 6,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'G#',
    position: 3,
  },
  'G#m': {
    fingers: [
      [4, 4, '3'],
      [5, 4, '2'],
    ],
    barres: [
      {
        fromString: 6,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'G#m',
    position: 3,
  },
  'G#m7': {
    fingers: [[5, 4, '2']],
    barres: [
      {
        fromString: 6,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'G#m7',
    position: 3,
  },
};
